import Bowser from "bowser";

export function getBrowserName() {
    const browserName = Bowser.getParser(window.navigator.userAgent).getBrowserName();
    if(browserName.toLowerCase() === 'chrome' || browserName.toLowerCase() === 'microsoft edge' || browserName.toLowerCase() === 'safari') {
        return browserName
    }
    return "Unknown"
}

export function getBrowserNameForTagging(isUserEnrolled = false) {
    if (isUserEnrolled) return "";
    const browserName = Bowser.getParser(window.navigator.userAgent).getBrowserName();
    if(browserName.toLowerCase() === 'chrome' || browserName.toLowerCase() === 'safari') {
        return browserName
    } else if (browserName.toLowerCase() === 'microsoft edge') {
        return 'Edge'
    }
    return "Unknown"
}

export function getPlatform() {
    const platformType = Bowser.getParser(window.navigator.userAgent).getPlatform();
    return platformType.type;
}

export function isDesktop() {
    const bowser = Bowser.parse(window.navigator.userAgent);
    const osName = bowser.os.name;
    const platformType = Bowser.getParser(window.navigator.userAgent).getPlatform().type;
    const maxTouchPoints = window.navigator.maxTouchPoints
    
    //check for desktops except macos
    if (platformType === 'desktop' && osName !== 'macOS') { return true } 
    //check for macos desktop
    else if (platformType === 'desktop' && osName === 'macOS' && maxTouchPoints === 0) { return true } 
    //check for ipad
    else if (platformType === 'desktop' && osName === 'macOS' && maxTouchPoints > 0) { return false }
    //check for all mobile and tablet devices 
    else if (platformType !== 'desktop') { return false }
    else { return false }
}